module.exports = __webpack_public_path__ + "img/card-title.c5eb682f.png";